import React, { useEffect, useState } from "react";
import { Card, Col, Dropdown, Nav, Row, Tab } from "react-bootstrap";
import CountUp from "react-countup";
import { Link, useNavigate } from "react-router-dom";
import { cardItems, DashboardDataModel, SaleseEntryCounts } from "../model";
import {
  getAllDashboardCounts,
  getDashboardFilterData,
} from "pages/Components/API_Modal/DashboardAPI/DashboardAPIModal";
import { HttpStatus } from "modules/core";
import { useLocation } from "react-router-dom";



const Widgets = () => {
  const [loading, setLoading] = useState(false);
  const [analyticsData, setAnalyticsData] = useState<any>(
    new DashboardDataModel()
  );
  const location = useLocation();



  const [selectedPeriods, setSelectedPeriods] = useState(() =>
    Object.fromEntries(cardItems.map((_, index) => [index, "Today"]))
  );

  const navigate = useNavigate()

  const navigateCards = ["customer",];
  const handleCardClick = (item: any) => {
    if (navigateCards.includes(item.titleForApi)) {
      navigate(`/${item.titleForApi}`);
    }
  };


  useEffect(() => {
    if (location.pathname == "/dashboard") {
      getAllDashboardCountsData();
    };
  }, [location.pathname]);

  const getAllDashboardCountsData = async () => {
    try {
      setLoading(true);
      const response = await getAllDashboardCounts();
      if (response && response.status === HttpStatus.Success) {
        setAnalyticsData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch Dashboard Data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePeriodChange = (index: number, period: string) => {
    const selectedTitle = cardItems[index]?.titleForApi;
    setSelectedPeriods((prev) => ({ ...prev, [index]: period }));
    getDashboardFilterDetails(index, selectedTitle, period);
  };

  const getDashboardFilterDetails = async (
    index: number,
    title: string,
    period: string
  ) => {
    try {
      setLoading(true);
      const now = new Date();

      let fromDateUTC = "";
      let toDateUTC = "";

      if (period === "Today") {

        const startOfDay = new Date(Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          0, 0, 0
        ));
        const endOfDay = new Date(Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          23, 59, 59
        ));

        fromDateUTC = startOfDay.toISOString();
        toDateUTC = endOfDay.toISOString();

        console.log(fromDateUTC,toDateUTC)

      } else if (period === "Month") {
        const startOfMonth = new Date(Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          1,
          0, 0, 0
        ));
        const endOfMonth = new Date(Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth() + 1,
          0,
          23, 59, 59
        ));

        fromDateUTC = startOfMonth.toISOString();
        toDateUTC = endOfMonth.toISOString();

      } else if (period === "Year") {
        const year = now.getUTCMonth() >= 3 ? now.getUTCFullYear() : now.getUTCFullYear() - 1;

        const startOfFY = new Date(Date.UTC(
          year,
          3, // April
          1,
          0, 0, 0
        ));
        const endOfFY = new Date(Date.UTC(
          year + 1,
          2, // March
          31,
          23, 59, 59
        ));

        fromDateUTC = startOfFY.toISOString();
        toDateUTC = endOfFY.toISOString();
      }

      const model = new SaleseEntryCounts();
      model.searchTable = title;
      model.fromDate = fromDateUTC;
      model.toDate = toDateUTC;

      const response = await getDashboardFilterData(model);
      if (response.status === HttpStatus.Success) {
        const updatedData = { ...analyticsData };
        const matchedItem = cardItems[index];
        if (matchedItem && matchedItem.valueKey) {
          updatedData[matchedItem.valueKey] = response.data;
          setAnalyticsData(updatedData);
        }
      }
    } catch (error) {
      console.error("Failed to fetch filtered Dashboard Data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [activeKey, setActiveKey] = useState("SalesEntry");
  const handleTabClick = (key: string, path: string) => {
    setTimeout(() => {
      setActiveKey(key);
      navigate(path);
    }, 400);
  };

  return (
    <React.Fragment>
      <h5 className="text-pantone mb-3">DASHBOARD</h5>
      <Col xl={12} sm={12}>
        <div className="shortcutTabs">
          <Tab.Container defaultActiveKey={activeKey}>
            <Nav
              as="ul"
              variant="pills"
              className="nav-pills-custom nav-primary nav-justified mb-3 rounded-5 p-1 bg-light"
            >
              <Nav.Item as="li">
                <Nav.Link
                  eventKey="SalesEntry"
                  onClick={() => handleTabClick("SalesEntry", "/new-transaction-entry")}
                  className="rounded-5 d-flex align-items-center justify-content-center"
                >
                  <i className="bx bx-list-plus fs-4 me-2"></i> Add Sales Entry
                </Nav.Link>
              </Nav.Item>

              <Nav.Item as="li">
                <Nav.Link
                  eventKey="EstimatePaymentReceipt"
                  onClick={() => handleTabClick("EstimatePaymentReceipt", "/make-to-order")}
                  className="rounded-5 d-flex align-items-center justify-content-center"
                >
                  <i className="bx bx-receipt fs-4 me-2"></i>  Make To Order
                </Nav.Link>
              </Nav.Item>

              <Nav.Item as="li">
                <Nav.Link
                  eventKey="Return"
                  onClick={() => handleTabClick("Return", "/return-to-franchise")}
                  className="rounded-5 d-flex align-items-center justify-content-center"
                >
                  <i className="bx bx-transfer fs-4 me-2"></i> Return Product
                </Nav.Link>
              </Nav.Item>

              <Nav.Item as="li">
                <Nav.Link
                  eventKey="Repair"
                  onClick={() => handleTabClick("Repair", "/repair-product-list")}
                  className="rounded-5 d-flex align-items-center justify-content-center"
                >
                  <i className="bx bx-cog fs-4 me-2"></i> Repair Product
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Tab.Container>
        </div>
      </Col>


      {/* <h5 className="text-pantone mb-3">DASHBOARD</h5> */}
      <Row className="g-3">
        {cardItems.map((item, index) => (
          // <Col xl={2} sm={5} key={index}>
          // <Col xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
          <Col xs={12} sm={6} md={4} lg={3} key={index}>

            <Card className="overflow-hidden position-relative h-100">
              <Card.Body
                onClick={() => item.titleForApi && navigateCards.includes(item.titleForApi) && handleCardClick(item)}
                className="p-3 d-flex flex-column justify-content-between"
                style={{
                  minHeight: "120px",
                  cursor: item.titleForApi && navigateCards.includes(item.titleForApi) ? "pointer" : "default",
                }}


              >
                {/* Dropdown or spacer to maintain height consistency */}
                <div
                  className="position-absolute"
                  style={{ top: "10px", right: "10px", height: "24px" }}
                >
                  {item.isFilter ? (
                    <Dropdown
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        size="sm"
                        className="no-caret border-0 p-0 text-muted"
                        style={{ backgroundColor: "transparent" }}
                      >
                        <i className="bi bi-three-dots-vertical fs-5"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="small">
                        {["Today", "Month", "Year"].map((period) => (
                          <Dropdown.Item
                            key={period}
                            active={selectedPeriods[index] === period}
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePeriodChange(index, period);
                            }}
                          >
                            {period}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <div style={{ width: "24px", height: "24px" }}></div>
                  )}
                </div>

                <div className="d-flex flex-column gap-1 align-items-start justify-content-start">
                  {item.isFilter && selectedPeriods[index] && (
                    <div
                    >
                      <p className="bg-warning-subtle badge text-warning mb-1">
                        {selectedPeriods[index]}
                      </p>
                    </div>
                  )}
                  <div
                    className={`${item.isFilter
                      ? "d-flex align-items-center gap-3 mt-1"
                      : "d-flex align-items-center gap-3 mt-4 pt-2"
                      }`}
                  >
                    {/* <div className=""> */}
                    <div className="avatar-sm flex-shrink-0">
                      <div className="avatar-title bg-light-subtle text-success-emphasis fs-3 rounded-5 border border-success">
                        <i className={item?.iconClass}></i>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <div className="d-flex flex-wrap text-muted gap-1">
                        <div className="flex-shrink-0">
                          <h5 className="mb-0">{item?.title}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <h4 className="mb-0 mt-3">
                  <span className="counter-value">
                    <CountUp
                      start={0}
                      end={analyticsData[item?.valueKey] || 0}
                      decimals={item.title === "Sales Revenue" ? 2 : 0}
                    />
                    <i className="bi bi-arrow-up me-1 text-success fs-5 ps-2"></i>
                  </span>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default Widgets;